import React, { useEffect, useRef, useState } from "react";
import { get_event, request_host_for_waitlist } from "../../Api/data";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { RxCross1 } from "react-icons/rx";

import { Modal } from "antd";

import { guest_dp_list } from "../../Api/storage";

import Arrow from "../../assets/SettingsPage/SVG/Arrow 1.svg";
import Plus from "../../assets/SettingsPage/SVG/plus.svg";
import "./EventPage.css";
import Gps from "../../assets/SettingsPage/SVG/gpsIconDark.png";
import { Power3, gsap } from "gsap";

import { getUserData } from "../../Api/homeapi";
import { acceptInvitationGuestInvite, getWaitList } from "../../Api/Waitlist";
import { useDispatch, useSelector } from "react-redux";
import PhoneAuth from "../../Auth/Box/PhoneAuth";
import GifLoader from "../Components/GifLoader";
import AdditionalDetails from "../../Guest/AdditionalDetails";
import PhoneAuthPopup from "../../Auth/Box/PhoneAuthPopup";

let title = "";

function HostPage(props) {
  let [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = useSelector((state) => state.SpotifyData).token;
  const paramIDS = searchParams.get("u");
  const [uid, id] = paramIDS.split("--i=");

  const [data, setData] = useState({});
  const [date, setDate] = useState(new Date());
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [guestUID, setGuestUID] = useState("");

  const [displayInvite, setdisplayInvite] = useState(false);


  const [showMaybeButton, setShowMaybeButton] = useState(false);
  const [showMaybeOptions, setShowMaybeOptions] = useState(false);
  const [invited, setInvited] = useState(false);
  const [maybe, setMaybe] = useState(false);
  const [drawerType, setdrawerType] = useState("missing");
  const [firebaseFiles, setFirebaseFiles] = useState([]);
  const [invites, setInvites] = useState([]);
  const [topThree, setTopThree] = useState([]);
  const [declined, setDeclined] = useState(false);

  const [popupRefNotGoing, setPopupRefNotGoing] = useState(useRef(null));

  const [popupRef, setPopupRef] = useState(useRef(null));
  const [popupRef2, setPopupRef2] = useState(useRef(null));
  const [popupRefAuth, setPopupRefAuth] = useState(useRef(null));
  const [maybeRef, setMaybeRef] = useState(useRef(null));
  const [inRef, setInRef] = useState(useRef(null));
  const [missingRef, setMissingRef] = useState(useRef(null));
  const isLoggedIn = useSelector((state) => state.Auth).isLoggedIn;
  const phoneNumber = useSelector((state) => state.Auth).phoneNumber;

  const [waitlist, setWaitList] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPhoneModalOpen, setIsPhoneModalOpen] = useState(
    false
  );
const [author,setauthor]=useState();
const [eventid,seteventid]=useState();
 
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const action = {
      type: "SET_SHOW_NAVIGATOR",
      showNavigator: false,
    };
    dispatch(action);
  }, []);
  useEffect(() => {}, [displayInvite]);

  const text = {
    missing: "Download the Surge Party app to not miss out on future parties.",
    in: "Please sign up and download the app to get a notified if there is any change.",
    maybe: "Please come back when you have changed your mind.",
  };

  const heading = {
    missing: `Ohh, you're missing out on ${data.title}`,
    in: "You have joined the waitlist",
    maybe: "No worries",
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const NotGoing=()=>{
    swipeUpAnimationNotGoing(popupRefNotGoing)
    setdisplayInvite(false)

  }

  const swipeUpAnimation = (refData) => {
    gsap.to(refData, 0.8, {
      top: "30%",
      ease: Power3.easeIn,
      display: "flex",
    });
  };
  const swipeUpAnimationAuth = (refData) => {
    gsap.to(refData, 0.8, {
      top: "0%",
      ease: Power3.easeIn,
      display: "flex",
    });
  };

  const swipeUpAnimationNotGoing = (refData) => {
    gsap.to(refData, 0.8, {
      top: "30%",
      ease: Power3.easeIn,
      display: "flex",
    });
  };

  const swipeDownAnimation = (refData) => {
    gsap.to(refData, 0.8, {
      top: "100%",
      ease: Power3.easeIn,
      display: "none",
    });
  };

  const fetchEventData = async () => {
    setLoader(true);
    console.log(id)
    const post = await get_event(uid, id);
    setauthor(post.author)
console.log(post)
    const files = await guest_dp_list();
    setFirebaseFiles(files);
    const gUID = localStorage.getItem("uid");

    const waitListData = await getWaitList(uid, id, gUID);
    console.log("Waitlist data ", waitListData ? waitListData : "")
    setWaitList(waitListData);
    setGuestUID(gUID);

    setData(post);
    title = post.title;
    const dat = post?.date ? new Date(post.date) : new Date();
    setDate(dat);

    setStartTime(dat.toLocaleTimeString([], { timeStyle: "short" }));
    var unixTime = dat.getTime();
    let total = unixTime + parseInt(post?.duration) * 60 * 60 * 1000;
    var d = new Date(total);
    setEndTime(d.toLocaleTimeString([], { timeStyle: "short" }));
    let all_invites = post.invites;
    let dpPresent = [];
    let dpAbsent = [];
    if (all_invites) {
      Object.keys(all_invites).map((invUID) => {
        if (files.includes(invUID)) {
          if (invUID === uid) {
            dpPresent.push(invUID);
          } else {
            dpAbsent.push(invUID);
          }
        } else {
          dpAbsent.push(invUID);
        }
      });
    }
    const invs = dpPresent.concat(dpAbsent);
    setInvites(invs);
    setTopThree(invs.slice(0, 5));

    if (gUID === post.author) {
      setdisplayInvite(false);
    } else {
      if (Object.keys(all_invites).includes(gUID)) {
        if (all_invites[gUID] === "Maybe") {
          setShowMaybeButton(true);
          setdisplayInvite(false);
          setMaybe(true);
        } else if (all_invites[gUID] === "NA") {
          setdisplayInvite(true);
        } else if (all_invites[gUID] === "No") {
          setDeclined(true);
        } else {
          setInvited(true);
          setdisplayInvite(false);
        }
      } else {
        setdisplayInvite(true);
      }
    }

    if (waitListData) {
      setdisplayInvite(false);
    }
    setLoader(false);
  };

  const accept_invitation = async (status) => {
    setLoader(true);
    if (isLoggedIn) {
      swipeUpAnimation(inRef);
      setdisplayInvite(false);
      setShowMaybeButton(false);
      setInvited(true);
      let tempUsr = await getUserData(guestUID);
      let postD = data;
      postD["inWaitlist"] = true;

      const resp = await acceptInvitationGuestInvite({
        uid: localStorage.getItem("uid"),
        id: id,
        author: postD.author,
        status: status,
        post: postD,
        displayName: tempUsr.firstname + " " + tempUsr.lastname,
        username: tempUsr.username,
        profilePic: Object.keys(tempUsr).includes("profilePic")
          ? tempUsr.profilePic
          : "",
      });
      setWaitList({
        status: status,
        displayName: tempUsr.firstname + " " + tempUsr.lastname,
        username: tempUsr.username,
        profilePic: Object.keys(tempUsr).includes("profilePic")
        ? tempUsr.profilePic
        : "",
    })
      await request_host_for_waitlist({
        author: data.author,
        guest_name: tempUsr.firstname + " " + tempUsr.lastname,
        event_name: data?.title,
        event_id: id,
      });
    } else {
      setdisplayInvite(true);
      setShowMaybeButton(true);
      setInvited(false);
      setIsPhoneModalOpen(true);
      swipeUpAnimationAuth(popupRefAuth)
    }
    setLoader(false);
  };
  useEffect(() => {   
    fetchEventData();
  }, [isLoggedIn]);
  const appInfo = {
    imageUrl: window.location.origin + "/icon.jpg",
    name: "Surge Party",
    publisher: "Surge Party",
    infoText: "Free - In App Store",
    linkButtonText: "VIEW",
    linkUrl: "https://apps.apple.com/us/app/surge-party/id1643038656",
  };

  const handleUploadMusic=()=>{
    let token =localStorage.getItem('token');
    if(token){
      navigate(`/spotify-playlist?u=${author}--i=${id}`)
    }else{
      navigate(`/spotify-auth`)
    }
   
  }
  return (
    <>
      {loader ? (
        <GifLoader />
      ) : (
        <div style={{ height: "110vh" }}>
          <div
            className="flex"
            style={{
              justifyContent: "space-between",
              padding: 10,
              alignItems: "center",
            }}
          >
            <div
              className="w-[40x] cursor-pointer"
              onClick={() => {
                const action = {
                  type: "SET_SHOW_NAVIGATOR",
                  showNavigator: true,
                };
                dispatch(action);

                navigate("/home");
              }}
            >
              <img src={Arrow} />
            </div>
            <div>
              <h2 className="text-center text-[white] font-bold bg-clip-text text-base">
                Event Details
              </h2>
            </div>
            <div
              onClick={() => {
                swipeUpAnimation(popupRef2);
              }}
            >
              <img className="w-[40px] font-bold cursor-pointer" src={Plus} />
            </div>
          </div>
          {/* Popup */}
          <Popup
            popupRef={popupRef}
            swipeDownAnimation={swipeDownAnimation}
            setPopupRef={setPopupRef}
            heading={"Wanna be part of the party playlist?"}
            text={
              "Download the app to upload your favourite songs and surge up the party"
            }
            btn="Download Surge Party"
          />
          <Popup
            popupRef={popupRefNotGoing}
            swipeDownAnimation={swipeDownAnimation}
            setPopupRef={setPopupRefNotGoing}
            heading={"Wait for next party"}
            text={
              "For a better experience, please download our app"
            }
            btn="Download Surge Party"
            
          />
          <Popup
            popupRef={popupRef2}
            setPopupRef={setPopupRef2}
            swipeDownAnimation={swipeDownAnimation}
            heading={"Wanna add more of your friends?"}
            text={
              "Download the Surge Party app to and invite your friends to the party!"
            }
            btn="Download Surge Party"
          />
          <Popup
            popupRef={maybeRef}
            setPopupRef={setMaybeRef}
            swipeDownAnimation={swipeDownAnimation}
            heading={heading.maybe}
            text={text.maybe}
            btn="Download Surge Party"
          />
          <Popup
            popupRef={inRef}
            setPopupRef={setInRef}
            swipeDownAnimation={swipeDownAnimation}
            heading={heading.in}
            text={text.in}
            btn="Download Surge Party"
          />
          <Popup
            popupRef={missingRef}
            setPopupRef={setMissingRef}
            swipeDownAnimation={swipeDownAnimation}
            heading={heading.missing}
            text={text.missing}
            btn="Download Surge Party"
          />
          
          {waitlist && isLoggedIn && phoneNumber ? (
            <>
              <div>
                <div
                  className="redirect_container flex"
                  style={{ borderTop: "1px solid grey" }}
                >
                  <a
                    style={{
                      color: "white",
                      textAlign: "center",
                      margin: "0 auto",
                      fontWeight: "bold",
                    }}
                  >
                    You have been added to waitlist.
                  </a>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
          {(displayInvite || !isLoggedIn) && (
            <div>
              <div className="redirect_container flex cursor-pointer">
                <a
                  className="red_button surge_in"
                  onClick={() => {

                    if(isLoggedIn) {
                      NotGoing()
                    }else{
                      setIsPhoneModalOpen(true)
                      swipeUpAnimationAuth(popupRefAuth)
                    }                  
                      // 
                  }}
                >
                  I'm not Going
                </a>
                <a
                  className="accept_button surge_in cursor-pointer"
                  onClick={() => {
                    accept_invitation("Yes");
                  }}
                >
                  Surge Me In
                </a>
              </div>
            </div>
          )}

          {data?.eventBanner ? (
            <img
              style={{objectFit: "cover"}}
              className=" mx-auto  w-[90%] h-[30%] rounded-lg shadow-lg mb-3"
              src={data?.eventBanner}
            />
          ) : (
            <img
              style={{objectFit: "cover"}}
              className=" mx-auto  w-[90%] h-[30%] rounded-lg shadow-lg mb-3"
              src={window.location.origin + "/icon.jpg"}
            />
          )}
          <div className="details_main">
            <div className="spacing">
              <h2 className="title">{data.title}</h2>
            </div>
            <div className="spacing">
              <p
                style={{ display: "flex", gap: 5, fontSize: 14, color: "grey" }}
              >
                Created by:{" "}
                <p className="magenta" style={{ fontSize: 14 }}>
                  {data.author === guestUID ? "You" : data.authorName}
                </p>
              </p>
            </div>
            <div className="row2 spacing">
              <div className="row3">
                <span className="icon1"></span>
                <p>
                  {startTime} - {endTime}
                </p>
              </div>
              <div className="row3">
                <span class="icon2"></span>
                <p>{date.toLocaleDateString()}</p>
              </div>
            </div>
            <div className="flex spacing" style={{ alignItems: "center" }}>
              <h4 style={{ fontSize: 14 }}>Duration: </h4>
              <p>{Math.ceil(data.duration)} hrs</p>
            </div>
            <div
              className="flex spacing"
              style={{ width: "95%", alignItems: "center" }}
            >
              <img src={Gps} style={{ width: 20, height: 20 }} />

              {isLoggedIn !== "" && isLoggedIn !== "false" && isLoggedIn ? (
                <>
                  {waitlist && isLoggedIn && phoneNumber ? (
                    <span
                      className="text-[white] text-[14px] cursor-pointer"
                      target="_blank"
                    >
                      <>{data.address ? data.address : data.location}</>
                    </span>
                  ) : (
                    <>
                          {displayInvite || !isLoggedIn ? (
                            <span
                              className="text-[white] text-[14px] cursor-pointer"
                            >
                              <>{data.address ? data.address : data.location}</>

                            </span>
                          ) : (
                            <a
                              className="text-[white] text-[14px] cursor-pointer underline comp"
                              target="_blank"
                              rel="noreferrer"
                              href={`https://www.google.com/maps/search/?api=1&query=${data?.latlong?.latitude},${data?.latlong?.longitude}`}
                            >
                              <>{data.address ? data.address : data.location}</>
                            </a>
                          )}
                        </>

                  )}
                </>
              ) : data.address ? (
                <p> {data.address}</p>
              ) : (
                <p className="text-white px-2 ">
                  <span>{data?.optimalLocation?.city} </span>
                  <span>{data.optimalLocation?.zip_code}</span>
                </p>
              )}
            </div>
          </div>

          <div className="flex guest-im-container">
            <div className="flex">
              {topThree.map((item, i) => {
                if (firebaseFiles.includes(item)) {
                  return (
                    <img
                      style={{ right: i * 10 }}
                      className="circle-image"
                      src={`https://firebasestorage.googleapis.com/v0/b/surge-party.appspot.com/o/users%2F${item}%2Fprofilepic?alt=media&token=0a3b87c0-0e01-4681-bd2c-71a753447fc5`}
                      alt="circle_image"
                    />
                  );
                } else {
                  return (
                    <img
                      style={{ right: i * 10 }}
                      src={window.location.origin + "/icon.jpg"}
                      className="circle-image"
                      alt="icon_image"
                    />
                  );
                }
              })}
            </div>
            <div className="guest-count-container flex">
              <div className="flex">
                <img
                  style={{ width: 40, height: 20 }}
                  src={window.location.origin + "/guestIcon.svg"}
                  alt="guess icon"
                />
                <div
                  onClick={() => {
                    if (
                      isLoggedIn !== "" &&
                      isLoggedIn !== "false" &&
                      isLoggedIn
                    ) {
                      navigate(`/guest-info?u=${uid}--i=${id}`);
                    } else {
                      setIsPhoneModalOpen(true);
                      swipeUpAnimationAuth(popupRefAuth)
                    }
                  }}
                  className="cursor-pointer"
                >
                  <p style={{ textDecoration: "underline" }}>
                    {invites.length} Guests
                  </p>
                </div>
              </div>
            </div>
          </div>
          {isLoggedIn !== "" && isLoggedIn !== "false" && isLoggedIn ? (
            <div className="description_container">
              <div className="description-text-container">
                <h3>Description</h3>
                <p className="desc_text">
                Upload your playlist to hear your favorite songs at the party
                </p>
                
              </div>
              {waitlist !== undefined && (
                <div
                  className="description-buttons cursor-pointer"
                  onClick={handleUploadMusic}
                >
                  <sapn className="upload-gradient-button ">
                    Upload your music taste
                  </sapn>
                </div>
              )}
              {localStorage.getItem("uid") !== data.author &&
              data.author &&
              Object.keys(data.invites).includes(
                localStorage.getItem("uid")
              ) ? (
                <>
                  <div
                    className="description-buttons"
                    onClick={() => navigate(`/qr?u=${uid}--i=${id}`)}
                  >
                    <span className="upload-gradient-button">Show QR</span>
                  </div>

                  <div
                  className="description-buttons cursor-pointer"
                  onClick={handleUploadMusic}
                >
                  <sapn className="upload-gradient-button ">
                    Upload your music taste
                  </sapn>
                </div>
                </>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <div className="my-3">
              <h1 className="font-semibold text-xl p-1 justify-center">
                Extra features will be unlocked after downloading the app
              </h1>
              <div className="popup-container">
                <a
                  className="button-download-container"
                  href="https://apps.apple.com/us/app/surge-party/id1643038656"
                >
                  <button className="bg-[white] flex items-center justify-center mx-auto p-3 rounded-3xl transform active:scale-75 transition-transform cursor-pointer">
                    <img
                      className="img_event"
                      style={{ width: 25, height: 15 }}
                      src={window.location.origin + "/downloadIcon.svg"}
                      alt="download_icon"
                    />
                    <span className="btn-wtext">Download Surge Party</span>
                  </button>
                </a>
              </div>
            </div>
          )}

          {/* <div className={`${isModalOpen?'flex':'hidden'} bg-[#141414] absolute top-10`}>
           
            <AdditionalDetails  comeFrom="event"   setIsModalOpen={setIsModalOpen} />
          </div> */}

          {(! isLoggedIn ) &&(
            isPhoneModalOpen && (
              <PhoneAuthPopup 
                popupRef={popupRefAuth}
                setPopupRef={setPopupRefAuth}
                swipeDownAnimation={swipeDownAnimation}
                heading={heading.missing}
                text={text.missing}
                btn="Download Surge Party"
              />
            )
          )}
          {/* {(! isLoggedIn ) &&(
            <PhoneAuth
              setIsPhoneModalOpen={setIsPhoneModalOpen}
              isPhoneModalOpen={isPhoneModalOpen}
              setIsModalOpen={setIsModalOpen}
            />
          )} */}
        </div>
      )}
    </>
  );
}

const Popup = (props) => {
  return (
    <div className="popup" ref={(el) => props.setPopupRef(el)}>
      <div
        className=""
        onClick={() => {
          props.swipeDownAnimation(props.popupRef);
        }}
      >
        <RxCross1 className="text-red-500 cursor-pointer  h-5 w-5 absolute top-2 right-2  bg-transparent" />
      </div>
      <div>
        <h3>{props.heading}</h3>
      </div>
      <div className="popup-container">
        <p>{props.text}</p>
      </div>
      {props.btn?<>
        <div className="popup-container">
        <a
          className="button-download-container"
          href="https://apps.apple.com/us/app/surge-party/id1643038656"
        >
          <div className="flex bg-white rounded-lg px-4 py-3 items-center justify-center mt-2 mb-3 shadow-lg">
            <img
              className="img_event"
              style={{ width: 25, height: 15 }}
              src={window.location.origin + "/downloadIcon.svg"}
              alt="Download_icon"
            />
            <a className="btn-wtext">{props.btn}</a>
          </div>
        </a>
      </div>
      </>:<></>}
    </div>
  );
};

export default HostPage;
